(window as any).global = window;
import process from 'process';
(window as any).process = process;
import 'crypto-browserify';
import { Buffer } from 'buffer';
(window as any).Buffer = Buffer;
